import { Shark, Utils } from "shark-mvc";
import moment from "moment";

import NousCoreModel from "./NousCoreModel";

class SampleRequest extends NousCoreModel {
	static STATUS_PENDING = 1;
	static STATUS_PICKED_UP = 6;
	static STATUS_PREPARING = 2;
	static STATUS_READY_FOR_PICKUP = 3;
	static STATUS_READY_FOR_SHIPPING = 4;
	static STATUS_SHIPPED = 5;

	contactGuid = "";
	contactName = ""; // Join Field
	deliveryDate = "0000-00-00 00:00:00";
	labCodes = [];
	notes = "";
	requestIndustrialSample = false;
	requestOutdoorSample = false;
	shipAddress = "";
	shippingData = {
		cost: 0,
		courierName: "",
		trackingCode: "",
	};
	shipToContact = false; //Se no ritiro in IPM per forza?
	userGuid = "";

	industrialRequest = {
		aquaPermLine: "",
		aquaPermLineNotes: "",
		basicSystems: [],
		basicSystemNotes: "",
		presumedArea: "",
		sampleSize: "",
		sampleCustomSize: "",
		stratigraphy: false,
		wallCoating: "",
		wallCoatingNotes: "",
	};

	outdoorRequest = {
		customInert: false,
		customInertNotes: "",
		drivableInert: {},
		extraSizeSample: [],
		extraSizeSampleCustomSize: "",
		extraSizeSampleNotes: "",
		outdoorSystems: [],
		outdoorSystemsNotes: "",
		pedestrianInert: {},
		presumedArea: "",
		sampleType: "",
	};

	__agentName = "";
	__deliveryDate = "";
	__deliveryDateLabel = "";
	__minDeliveryDate = "" ;
	__requestTypeLabel = "";
	__showIndustrialCustomSize = false;
	__showOutdoorCustomSize = false;
	__shippingCost = "" ;
	__shippingCostLabel = "" ;
	__shipTypeLabel = "" ;
	__showLabCodesButton = true;
	__statusLabel = "" ;

	__status_picked_up = false;
	__status_pending = false;
	__status_preparing = false;
	__status_ready_for_pickup = false;
	__status_ready_for_shipping = false;
	__status_shipped = false;

	constructor (data) {
		super(data);

		if (data) {
			this.import(data);
		}
	}

	addLabCode () {
		const newLabCode = Shark.getInstance("__smart__", {
			code: "",
			description: "",
			index: this.labCodes.length,
		});

		this.labCodes.push(newLabCode);
		this.reindexLabCodes();
	}

	deleteLabCode (index) {
		if (this.labCodes.length >= index) {
			this.labCodes.splice(index, 1);
			this.reindexLabCodes();
		}
	}

	reindexLabCodes () {
		this.labCodes.forEach((item, index) => item.index = index);
		console.log(this);
	}

	export () {
		const exportData = super.export();

		exportData.deliveryDate = this.exportDateField("deliveryDate");
		exportData.industrialRequest = this.exportObjectField("industrialRequest");

		exportData.labCodes = this.labCodes.map(item => item.export());
		exportData.labCodes = JSON.stringify(exportData.labCodes);

		// exportData.outdoorRequest = this.exportObjectField("outdoorRequest");
		exportData.outdoorRequest = Object.assign({}, this.outdoorRequest);

		for (let currProp in this.outdoorRequest.drivableInert) {
			if (this.outdoorRequest.drivableInert[currProp] === "") {
				delete exportData.outdoorRequest.drivableInert[currProp];
			}
		}
		for (let currProp in this.outdoorRequest.pedestrianInert) {
			if (this.outdoorRequest.pedestrianInert[currProp] === "") {
				delete exportData.outdoorRequest.pedestrianInert[currProp];
			}
		}
		exportData.outdoorRequest = JSON.stringify(exportData.outdoorRequest);
		
		exportData.requestIndustrialSample = this.exportBooleanField("requestIndustrialSample");
		exportData.requestOutdoorSample = this.exportBooleanField("requestOutdoorSample");
		exportData.shippingData = this.exportObjectField("shippingData");
		exportData.shipToContact = this.exportBooleanField("shipToContact");

		return exportData;
	}

	import (data, options) {
		super.import(data, options);

		if (this.importDateField("deliveryDate", data.deliveryDate)) {
			this.__deliveryDate = this.deliveryDate.format("YYYY-MM-DD");
			this.__deliveryDateLabel = this.deliveryDate.format("DD/MM/YYYY");
		}

		this.importBooleanField("requestIndustrialSample", data.requestIndustrialSample);
		this.importBooleanField("requestOutdoorSample", data.requestOutdoorSample);
		this.importBooleanField("shipToContact", data.shipToContact);

		this.parseLabCodes();
		this.parseShippingData();
		this.parseStatus();
		this.parseType();
		this.parseUser();

		this.__showIndustrialCustomSize = this.industrialRequest?.sampleCustomSize !== "";
		this.__showOutdoorCustomSize = this.outdoorRequest?.extraSizeSampleCustomSize !== "";
		this.__shipTypeLabel = this.shipToContact ? "Spedire al cliente" : "Ritiro in IPM";
	}

	on__deliveryDateChanged () {
		this.deliveryDate = moment(this.__deliveryDate);
		this.__deliveryDateLabel = this.deliveryDate.format("DD/MM/YYYY");
	}

	on__shippingCostChanged (data) {
		console.log(data);
		this.shippingData.cost = parseFloat(this.__shippingCost.replace(",", "."));
	}

	// Dave:Warn: Questa cosa di referenziare i node da qui continua a non piacermi
	onIndustrialRequest_sampleSizeChanged () {
		const input = document.querySelector("#industrialRequestOtherSampleSizeField");
		input.value = "";

		if (this.industrialRequest.sampleSize === "Altro") {
			input.classList.remove("d-none");
			input.focus();
		}
		else {
			input.classList.add("d-none");
		}
	}

	// Dave:Warn: Questa cosa di referenziare i node da qui continua a non piacermi
	onOutdoorRequest_extraSizeSampleChanged (data) {
		const input = document.querySelector("#outdoorRequestOtherSampleSizeField");
		input.value = "";

		if (data.newValue.includes("Altro")) {
			input.classList.remove("d-none");
			input.focus();
		}
		else {
			input.classList.add("d-none");
		}
	}

	onShipToContactChanged (data) {
		this.shipToContact = data.newValue === "true";
	}

	onStatusChanged () {
		this.parseStatus();
	}

	parseLabCodes () {
		if (this.labCodes && Array.isArray(this.labCodes)) {
			this.labCodes = this.labCodes.map(item => Shark.getInstance("__smart__", item));
		}
	}

	parseShippingData () {
		if (this.status === SampleRequest.STATUS_SHIPPED) {
			this.__shippingCost = this?.shippingData?.cost.toFixed(2).replace(".", ",");
			this.__shippingCostLabel = Shark.$store.currencyFormatter.format(this?.shippingData?.cost);
		}
		else {
			this.__shippingCost = "0,00";
			this.__shippingCostLabel = "";
		}
	}

	parseStatus () {
		switch (this.status) {
			case SampleRequest.STATUS_PENDING:
				this.__status_pending = true;
				this.__statusLabel = "In attesa";
				this.__statusCSSClass = "sr-status-pending";
				this.__showLabCodesButton = false;
				break;
			case SampleRequest.STATUS_PICKED_UP:
				this.__status_picked_up = true;
				this.__statusLabel = "Ritirata";
				this.__statusCSSClass = "sr-status-picked-up";
				break;
			case SampleRequest.STATUS_PREPARING:
				this.__status_preparing = true;
				this.__statusLabel = "In preparazione";
				this.__statusCSSClass = "sr-status-preparing";
				break;
			case SampleRequest.STATUS_READY_FOR_PICKUP:
				this.__status_ready_for_pickup = true;
				this.__statusLabel = "Pronta per il ritiro";
				this.__statusCSSClass = "sr-status-ready-for-pickup";
				break;
			case SampleRequest.STATUS_READY_FOR_SHIPPING:
				this.__status_ready_for_shipping = true;
				this.__statusLabel = "Pronta per la spedizione";
				this.__statusCSSClass = "sr-status-ready-for-shipping";
				break;
			case SampleRequest.STATUS_SHIPPED:
				this.__status_shipped = true;
				this.__statusLabel = "Spedita";
				this.__statusCSSClass = "sr-status-shipped";
				break;
		}
	}

	parseType () {
		this.__requestTypeLabel = "";

		if (this.requestIndustrialSample) {
			this.__requestTypeLabel += ", Industriale";
		}
		if (this.requestOutdoorSample) {
			this.__requestTypeLabel += ", Outdoor";
		}
		if (this.__requestTypeLabel && this.__requestTypeLabel !== "") {
			this.__requestTypeLabel = this.__requestTypeLabel.slice(2);
		}
	}

	parseUser () {
		const { agentList } = Shark.get();
		
		if (agentList) {
			const currAgent = Utils.safp(agentList, "guid", this.userGuid);
			if (currAgent) {
				this.__agentName = currAgent.__fullName;
				// this.__reportData.agentGuid = currAgent.guid;
				// this.__reportData.agentName = currAgent.__fullName;
			}
		}
	}

	validate () {
		const errors = [];
		this.__errors = {};

		if (!this.requestIndustrialSample && !this.requestOutdoorSample) {
			errors.push("Devi attivare almeno una richiestra tra Industriale e Outdoor.");
		}

		if (this.requestIndustrialSample) {
			if (this.industrialRequest.sampleSize === "") {
				errors.push("Devi indicare la dimensione del campione per la richiesta Industriale.");
				this.__errors["industrialRequest.sampleSize"] = true;
			}

			if (this.industrialRequest.sampleSize === "Altro" && this.industrialRequest.sampleCustomSize.trim() === "") {
				errors.push("Hai chiesto una misura personalizzata ma non hai indicato la dimensione del campione per la richiesta Industriale.");
				this.__errors["industrialRequest.sampleCustomSize"] = true;
			}

			if (this.industrialRequest.basicSystemNotes.trim() !== "" && this.industrialRequest.basicSystems.length === 0) {
				errors.push("Hai inserito delle note nella sezione 'IPM BASIC LINE', ma non hai scelto un Sistema nella richiesta Industriale.");
				this.__errors["industrialRequest.basicSystems"] = true;
				this.__errors["industrialRequest.basicSystemNotes"] = true;
			}

			if (this.industrialRequest.wallCoatingNotes.trim() !== "" && this.industrialRequest.wallCoating.trim() === "") {
				errors.push("Hai inserito delle note nella sezione 'IPM RIVESTIMENTI MURALI E ANTICORROSIVI', ma non hai scelto un Sistema nella richiesta Industriale.");
				this.__errors["industrialRequest.wallCoating"] = true;
				this.__errors["industrialRequest.wallCoatingNotes"] = true;
			}

			if (this.industrialRequest.aquaPermLineNotes.trim() !== "" && this.industrialRequest.aquaPermLine.trim() === "") {
				errors.push("Hai inserito delle note nella sezione 'IPM AQUAPERM LINE', ma non hai scelto un Sistema nella richiesta Industriale.");
				this.__errors["industrialRequest.aquaPermLine"] = true;
				this.__errors["industrialRequest.aquaPermLineNotes"] = true;
			}
		}
		
		if (this.requestOutdoorSample) {
			if (!this.outdoorRequest.customInert && Object.keys(this.outdoorRequest.drivableInert).length === 0 && this.outdoorRequest.outdoorSystems.length === 0 && Object.keys(this.outdoorRequest.pedestrianInert).length === 0) {
				errors.push("Non hai scelto nessun inerte per la richiesta Outdoor.");
			}
			
			if (this.outdoorRequest.customInert && this.outdoorRequest.customInertNotes.trim() === "") {
				errors.push("Hai chiesto un inerte personalizzato ma non hai inserito i dettagli per la richiesta Outdoor.");
				this.__errors["outdoorRequest.customInertNotes"] = true;
			}

			if (this.outdoorRequest.sampleType === "") {
				errors.push("Devi indicare la tipologia per la richiesta Outdoor.");
				this.__errors["outdoorRequest.sampleType"] = true;
			}
			else if (this.outdoorRequest.sampleType === "CAMPIONE EXTRAFORMATO" && this.outdoorRequest.extraSizeSample.length === 0) {
				errors.push("Devi indicare la dimensione del campione extraformato per la richiesta Outdoor.");
				this.__errors["outdoorRequest.extraSizeSample"] = true;
			}

			if (this.outdoorRequest.extraSizeSample.includes("Altro") && this.outdoorRequest.extraSizeSampleCustomSize.trim() === "") {
				errors.push("Hai chiesto una misura personalizzata ma non hai indicato la dimensione del campione per la richiesta Outdoor.");
				this.__errors["industrialRequest.sampleCustomSize"] = true;
			}

			if (this.outdoorRequest.extraSizeSampleNotes.trim() !== "" && this.outdoorRequest.extraSizeSample.length === 0) {
				errors.push("Hai inserito delle note nella sezione 'DIMENSIONE CAMPIONE EXTRAFORMATO', ma non hai scelto una Dimensione Extraformato nella richiesta Outdoor.");
				this.__errors["outdoorRequest.extraSizeSample"] = true;
				this.__errors["outdoorRequest.extraSizeSampleNotes"] = true;
			}

			if (this.outdoorRequest.outdoorSystemsNotes.trim() !== "" && this.outdoorRequest.outdoorSystems.length === 0) {
				errors.push("Hai inserito delle note nella sezione 'ALTRI CAMPIONI OUTDOOR', ma non hai scelto un Sistema nella richiesta Outdoor.");
				this.__errors["outdoorRequest.outdoorSystems"] = true;
				this.__errors["outdoorRequest.outdoorSystemsNotes"] = true;
			}
		}

		if (this.shipToContact && this.shipAddress.trim() === "") {
			errors.push("Devi indicare l'indirizzo per la spedizione al Contatto.");
			this.__errors.shipToContact = true;
			this.__errors.shipAddress = true;
		}
		
		this.__isValid = this.__errorsCount === 0;

		return errors;
	}
}

Shark.registerModel("SampleRequest", SampleRequest);

export default SampleRequest;